// UnreadContext.js
import React, { createContext, useState, useEffect, useContext } from "react";
import API from "./api";
import { AuthContext } from "./AuthContext";

export const UnreadContext = createContext();

export const UnreadProvider = ({ children }) => {
  const [unreadCounts, setUnreadCounts] = useState({});
  const [unreadUsers, setUnreadUsers] = useState(0);
  const [unreadClaims, setUnreadClaims] = useState(0);

  const { user, loading, token } = useContext(AuthContext);

  const fetchUnreadCounts = async () => {
    if (!user || !token) return; // do nothing if no user/token

    try {
      const res = await API.get("/unread-counts");
      if (!res.data) return;

      if (res.data.type === "admin") {
        const map = {};
        res.data.unreadAllInvoices.forEach((item) => {
          map[item._id] = item.unreadCount;
        });
        setUnreadCounts(map);
        setUnreadUsers(res.data.unreadAllInvoices.length);
        setUnreadClaims(0);
      }

      if (res.data.type === "user") {
        const map = {};
        res.data.unreadByInvoice.forEach((item) => {
          map[item._id] = item.unreadCount;
        });
        setUnreadCounts(map);
        setUnreadClaims(res.data.unreadByInvoice.length);
        setUnreadUsers(0);
      }
    } catch (err) {
      // ❌ don't throw or update state on 401
      if (err.response?.status === 401) return;
      console.error("Failed to fetch unread counts", err);
    }
  };

  useEffect(() => {
    // ✅ fetch only when AuthProvider finished loading and user exists
    if (!loading && user && token) {
      fetchUnreadCounts();
    }
  }, [loading, user, token]);

  return (
    <UnreadContext.Provider
      value={{ unreadCounts, unreadClaims, unreadUsers, fetchUnreadCounts }}
    >
      {children}
    </UnreadContext.Provider>
  );
};
